import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EtScreenRecorderService {

  public actionSubject = new Subject<{action: "start" | "stop" | "finished" | "canceled", data?: Blob, userId?: string, referenceId?: string, referenceType?: string}>();
  public activePromise: Promise<Blob>;
  public enabled = false;

  constructor(
  ) { }

  startRecording(userId: string, referenceId: string, referenceType: "mealPlan" | "trackedWorkout" = "mealPlan") {
    this.actionSubject.next({action: "start", userId: userId, referenceId: referenceId, referenceType: referenceType});
    return this.actionSubject
  }

  stopRecording() {
    this.actionSubject.next({action: "stop"});
  }

  getActionSubject(): Subject<any> {
    return this.actionSubject;
  }
}